import { render, staticRenderFns } from "./CollaboratorInvited.vue?vue&type=template&id=40dc3008"
import script from "./CollaboratorInvited.vue?vue&type=script&lang=js"
export * from "./CollaboratorInvited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports